import { render, staticRenderFns } from "./homeScan.vue?vue&type=template&id=a13acc10&scoped=true"
import script from "./homeScan.vue?vue&type=script&lang=js"
export * from "./homeScan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13acc10",
  null
  
)

export default component.exports